// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"00652f0a","453":"886e5041","732":"960ac330","977":"1784b65c"}[chunkId] + ".chunk.js";
};